import { env } from './env'

type SentryModule = typeof import('@sentry/react')

let sentry: Promise<SentryModule> | null = null

/**
 * Error monitoring. No-op without a DSN. Loaded after first paint so it never slows start-up on
 * 3G (it is not part of the rep bundle budget). Never sends personal data or request bodies.
 */
export function initSentry() {
  if (!env.sentryDsn || sentry) return
  sentry = import('@sentry/react').then((Sentry) => {
    Sentry.init({
      dsn: env.sentryDsn,
      environment: env.appEnv,
      release: env.version,
      tracesSampleRate: 0.05,
      beforeSend(event) {
        if (event.request) {
          delete event.request.cookies
          delete event.request.data
        }
        if (event.user) event.user = { id: event.user.id }
        return event
      },
    })
    return Sentry
  })
}

export function setSentryUser(userId: string | null) {
  void sentry?.then((Sentry) => Sentry.setUser(userId ? { id: userId } : null))
}

export function captureException(error: unknown) {
  void sentry?.then((Sentry) => Sentry.captureException(error))
}
